import styled from 'styled-components';

export const VideoCallScreenWrapper = styled.div`
    position: fixed;
    left: 98vw;
    width: 95vw;
`;

export const ControlPanel = styled.div`
    position: relative;
    bottom: 70px;
    left: 90%;
    transform: translateX(-50%);
    display: flex;
    gap: 15px;
    z-index: 1000;
`;

export const ControlButton = styled.button<{isActive?: boolean; $focused: boolean}>`
    padding: 12px 16px;
    border-radius: 8px;
    background: ${(props) => (props.isActive ? '#ff4444' : '#333')};
    color: white;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    border: ${({$focused}) => ($focused ? '#00bfff' : 'none')};
    box-shadow: ${({$focused}) => ($focused ? '0 0 10px rgba(0, 191, 255, 1)' : 'none')};

    &:hover {
        background: ${(props) => (props.isActive ? '#ff6666' : '#555')};
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const ExitButton = styled(ControlButton)<{$focused: boolean}>`
    background: #ff4444;

    &:hover {
        background: #ff6666;
    }
`;

export const InviteUserButton = styled(ControlButton)<{$focused: boolean}>`
    background: #555;

    &:hover {
        background: #3ab8ff;
    }
`;
